import { Variants } from 'framer-motion'

// Smooth easing curves for luxury feel
// Using tuple type for cubic-bezier values
export const smoothEasing: [number, number, number, number] = [0.22, 1, 0.36, 1]

// Fade up animation - most common
export const fadeUpVariants: Variants = {
  hidden: {
    opacity: 0,
    y: 40,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
      ease: smoothEasing,
    },
  },
}

// Fade up with scale - for cards
export const fadeUpScaleVariants: Variants = {
  hidden: {
    opacity: 0,
    y: 30,
    scale: 0.95,
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.6,
      ease: smoothEasing,
    },
  },
}

// Stagger container - for grids
export const staggerContainerVariants: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.1,
    },
  },
}

// Stagger item - for individual items in grids
export const staggerItemVariants: Variants = {
  hidden: {
    opacity: 0,
    y: 30,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: smoothEasing,
    },
  },
}

// Text reveal - for hero
export const textRevealVariants: Variants = {
  hidden: {
    opacity: 0,
    y: 20,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: smoothEasing,
    },
  },
}

// Accordion content
export const accordionContentVariants: Variants = {
  collapsed: {
    height: 0,
    opacity: 0,
    transition: {
      height: { duration: 0.3, ease: smoothEasing },
      opacity: { duration: 0.2 },
    },
  },
  expanded: {
    height: 'auto',
    opacity: 1,
    transition: {
      height: { duration: 0.3, ease: smoothEasing },
      opacity: { duration: 0.3, delay: 0.1 },
    },
  },
}

// Icon rotation for accordion
export const iconRotateVariants: Variants = {
  collapsed: { rotate: 0 },
  expanded: { rotate: 180 },
}

// Button pulse glow
export const pulseGlowVariants: Variants = {
  initial: {
    boxShadow: '0 0 0 0 rgba(26, 114, 96, 0)',
  },
  pulse: {
    boxShadow: ['0 0 0 0 rgba(26, 114, 96, 0.4)', '0 0 0 15px rgba(26, 114, 96, 0)'],
    transition: {
      duration: 1.5,
      repeat: Infinity,
      repeatDelay: 3,
    },
  },
}
